"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var pricing_1 = require("../../common/ui-selectors/channel/pricing");
function canAccessChannelWithSubscription(channel) {
    return pricing_1.isSubscriptionEnabled(channel) && pricing_1.isSubscribedTo(channel);
}
exports.canAccessChannelWithSubscription = canAccessChannelWithSubscription;
function canSubscribeToChannel(channel) {
    return pricing_1.isSubscriptionEnabled(channel) && !pricing_1.isSubscribedTo(channel);
}
exports.canSubscribeToChannel = canSubscribeToChannel;
//# sourceMappingURL=channel-access.js.map